import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';


import { getEnvs, hasAllPermissions, hasPermission, plantillaExcelENUM, useCheckPermissions, useTableFilter, useTableServerSideFiltering, useUploadFile } from '@/shared';
import { usefetchProveedor, useUpdateProveedor } from '@/shared/actions/erp';
import {
  CustomSearch,
  GeneralTable,
 
  SingleTableBoxScene,
  SwitchComponente,
} from '@/shared/components/ui';

import { PROVEEDOR } from '@/shared/interfaces';
import { PermissionsEnum } from '@/auth/interfaces';
import { useUiConfirmModalStore } from '@/store/ui';
const { VITE_BUCKET_BASE } = getEnvs();

const returnUrlProveedor = '/compras/proveedores';

export interface ProveedorPageInterface { }

const ProveedorPage: React.FC<ProveedorPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_proveedor)


  const navigate = useNavigate();
  /* const [paymentMethods, setPaymentMethods] = useState<PaymentMethod[]>([]); */
  /* const [isModalOpenFormaPago, setIsModalOpenFormaPago] = useState(false); */
  ///* global state
  const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    s => s.setConfirmDialogIsOpen
  );
  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    cleanFilter
  } = useTableFilter();
  const { pageIndex } = pagination;
  const {
    columnFilters,
    setColumnFilters,
    filterObject
  } = useTableServerSideFiltering()
  ///* fetch data
  const {
    data: proveedorPagingRes,
    isLoading,
    isRefetching,
  } = usefetchProveedor({
    page: pageIndex + 1,
    identificacion: searchTerm,
    ...filterObject,
    filterByState: false
  });
  ///* mutations
  const updateProveedorMutation = useUpdateProveedor({ navigate, returnUrl: returnUrlProveedor });
  ///* handlers
  const onEdit = (original: PROVEEDOR) => {

    navigate(`${returnUrlProveedor}/editar/${original.id_proveedor}`);
  };

  ///* columns
  const columns = useMemo<MRT_ColumnDef<PROVEEDOR>[]>(
    () => [
      {
        accessorKey: 'numero_referencia',
        header: 'Numero referencia',
        size: 200,
      },
      {
        accessorKey: 'identificacion',
        header: 'Identificacion',
        size: 200,
      },
      {
        accessorKey: 'razon_social',
        header: 'Razon social',
        size: 200,
      },
      {
        accessorKey: 'nombre_comercial',
        header: 'Nombre comercial',
        size: 200,
      },
      {
        accessorKey: 'direccion',
        header: 'Direccion',
        size: 200,
      },
      {
        accessorKey: 'email',
        header: 'email',
        size: 200,
      },
      {
        accessorKey: 'telefono_1',
        header: 'telefono 1',
        size: 200,
      },
      {
        accessorKey: 'telefono_2',
        header: 'telefono 2',
        size: 200,
      },
      {
        accessorKey: 'contacto',
        header: 'contacto',
        size: 200,
      },
      {
        accessorKey: 'contacto_cargo',
        header: 'cargo del contacto',
        size: 200,
      },
      {
        accessorKey: 'contacto_email_1',
        header: 'contacto email 1',
        size: 200,
      },
      {
        accessorKey: 'contacto_email_2',
        header: 'contacto email 2',
        size: 200,
      },
      {
        accessorKey: 'tipo_regimen',
        header: 'tipo regimen',
        size: 200,
      },
      {
        accessorKey: 'pais',
        header: 'pais proveedor',
        size: 200,
      },
      {
        accessorKey: 'provincia',
        header: 'provincia',
        size: 200,
      },
      {
        accessorKey: 'ciudad',
        header: 'ciudad',
        size: 200,
      },
      {
        accessorKey: 'porcentaje_ret_iva_bienes_data.porcentaje',
        header: 'porcentaje retencion iva bienes',
        size: 200,
        Cell: ({ row }) => row.original.porcentaje_ret_iva_bienes || 'N/A'
      },
      {
        accessorKey: 'porcentaje_ret_iva_servicios_data.porcentaje',
        header: 'porcentaje retencion iva servicios',
        size: 200,
        Cell: ({ row }) => row.original.porcentaje_ret_iva_servicios || 'N/A'
      },
      {
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <SwitchComponente
            estadoSwitch={row.original.estado}
            titulo={row.original.estado ? 'Activo' : 'Inactivo'}
            setEstadoSwitch={proveedor => {
              if (!hasPermission(PermissionsEnum.api_change_departamento)) return;
              setConfirmDialog({
                isOpen: true,
                title: 'Cambiar Estado',
                subtitle:
                  '¿Está seguro que desea cambiar el estado de este registro ?',
                onConfirm: () => {
                  setConfirmDialogIsOpen(false);
                  updateProveedorMutation.mutate({
                    id: row.original.id_proveedor!,
                    data: {
                      ...row.original,
                      estado: proveedor as boolean,
                    },
                  });
                },
              });
            }}
          />
        ),
      },
    ],
    []
  );
  const {
    fileInputRef,
    handleImportProveedor,
    //isPendingProveedorExcel
  } = useUploadFile()
  //console.log(handleImportProveedor)
  //if (isPendingProveedorExcel) return <LoaderComponent />

  return (
    <SingleTableBoxScene
      title="Proveedores"
      urlRedirect={`${returnUrlProveedor}/crear`}
      enableRedirect={hasPermission(PermissionsEnum.api_add_proveedor)}
      enableUploadFile={true}
      fileInputRef={fileInputRef}
      handleFileUpload={handleImportProveedor}
      urlDownloadPlantilla={
        "/" + VITE_BUCKET_BASE + plantillaExcelENUM.PLANTILLA_PROVEEDOR
      }
      urlDownloadNameExcel={"plantilla_proveedor"}
    >
      <CustomSearch
        onChange={onChangeFilter}
        value={globalFilter}
        text="Proveedor"
        cleanFilter={cleanFilter}
      />

      <GeneralTable<PROVEEDOR>
        columns={columns}
        data={proveedorPagingRes?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={proveedorPagingRes?.data?.count}
        //
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        enableManualFiltering={true}
        enableSorting={false}
        // // actions
        enableColumnActions={hasAllPermissions([
          PermissionsEnum.api_change_proveedor,
        ])}
        actionsColumnSize={120}
        // crud
        onEdit={onEdit}
        canEdit={hasAllPermissions([
          PermissionsEnum.api_change_proveedor,
        ])}
        canDelete={false}
      />
      {/*            <ScrollableDialogProps
        open={isModalOpenFormaPago}
        title="Metodos de pago"
        cancelTextBtn="Cerrar"
        onClose={() => setIsModalOpenFormaPago(false)}
        minWidth="80%"
        contentNode={
          <>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                {paymentMethods.length > 0 && (
                  <SampleTable<PaymentMethod>
                    columns={columnsFormasPago}
                    data={paymentMethods}
                  />
                )}
              </Grid>
            </Grid>
          </>
        }
      /> */}
    </SingleTableBoxScene>
  );
};
export default ProveedorPage;